import React from "react";
import styled from "styled-components";

export const getDiagnosticModalTitle = (pageToShow) => {
  if (pageToShow === 1) {
    return "Droga się tworzy gdy idziesz…";
  } else {
    return "Modal";
  }
};

export const getDiagnosticModalComponentBasedOnPage = (pageToShow) => {
  if (pageToShow === 1) {
    return (
      <ModalTextWrapper>
        <TextWithIcon>
          W zależności od odpowiedzi jakich udzielisz tutaj i na innych
          ekranach, Twoja droga może Cię zaprowadzić w rozmaite miejsca.
        </TextWithIcon>
        {/* <TextWithIcon>Wypatruj w prawym górnym rogu ikonki <span><img src='/assets/front/img/edustrada/personalizationIcon.png' /></span> i dopasowuj tematy, ćwiczenia i narzędzia do swoich potrzeb!</TextWithIcon> */}
      </ModalTextWrapper>
    );
  } else {
    <p>Nothing to show</p>;
  }
};

const ModalTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TextWithIcon = styled.span`
  svg,
  img {
    display: inline;
    margin: 0 0.125em;
    padding: 0;
    max-width: 30px;
    max-height: 30px;
    vertical-align: bottom;
  }

  img {
    max-height: 28px;
  }

  &:last-child {
    svg {
      max-width: 25px;
      max-height: 25px;
    }
  }
`;
